import Vue from "vue";
import VueRouter from "vue-router";

import Advisors from "@/views/Advisors";
import Connection from "@/views/Connection";
import Home from "@/views/Home";
import Login from "@/views/Login";
import Logout from "@/views/Logout";
import Profile from "@/views/Profile";
import The404 from "@/views/The404";
import Updates from "@/views/Updates";

import store from "@/store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
  },
  {
    path: "/advisors",
    name: "advisors",
    component: Advisors,
    meta: {
      title: "Advisors",
    },
  },
  {
    path: "/updates",
    name: "updates",
    component: Updates,
    meta: {
      title: "Updates",
    },
  },
  {
    path: "/profile",
    name: "profile",
    component: Profile,
    meta: {
      title: "Profile",
    },
  },
  {
    path: "/connection/:connectionId/:action?",
    name: "connection",
    component: Connection,
    meta: {
      public: true,
    },
  },
  {
    path: "/login",
    name: "login",
    component: Login,
    meta: {
      public: true,
    },
  },
  {
    path: "/logout",
    name: "logout",
    component: Logout,
    meta: {
      public: true,
    },
  },
  {
    path: "*",
    name: "The404",
    component: The404,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  // TODO - ADD LOADING STATE PLEASE
  if (!store.state.initialized) {
    await store.dispatch("init");
  }
  if (!store.state.auth.signedIn && !to.meta.public) {
    return next({
      path: "/login",
      query: { redirect: to.fullPath },
    });
  }

  if (store.state.auth.signedIn && to.name === "login") {
    return next({ path: "/" });
  }

  const title = to.meta.title;
  document.title = `${title ? title + " | " : ""}Precommit`;

  next();
});

export default router;
